import styled from 'styled-components';

import { RadioGroup as RadioGroupBase } from '../../Insurance.styles';

export const RadioGroup = styled(RadioGroupBase)`
  display: flex;
  gap: 12px;
`;

export { Radio } from '../../Insurance.styles';
